import gql from 'graphql-tag';

export const VERSION_QUERY = gql`
  query VersionQuery {
    version {
      version
      commitSha
      releasedAt
    }
  }
`;

export default VERSION_QUERY;
